import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import Skeleton from '../../../../common/skeleton';
const PlanDetailsSkeleton = () => {
  return (
    <>
      <Card className="w-100">
        <Card.Body>
          <Row className="align-items-center">
            <Col md={4} lg={4} xs={12}>
              <div className="first-block">
                <div className="text-center">
                  <Skeleton
                    count={1}
                    height={12}
                    width={250}
                    className="plan-details-skeleton"
                  />
                </div>
                <div className="text-center">
                  <Skeleton
                    count={2}
                    height={12}
                    width={150}
                    className="plan-details-skeleton"
                  />
                </div>
                <div className="text-center">
                  <Skeleton
                    count={1}
                    height={12}
                    width={300}
                    className="plan-details-skeleton"
                  />
                </div>
                <div className="text-center">
                  <Skeleton
                    count={1}
                    height={12}
                    width={250}
                    className="plan-details-skeleton"
                  />
                </div>
              </div>
            </Col>
            <Col
              md={8}
              lg={8}
              xs={12}
              className="mt-5 mt-sm-0 second-block account-details-section-labels"
            >
              <Row>
                <Col md={6} lg={6} xs={12}>
                  <Skeleton
                    count={4}
                    height={12}
                    className="plan-details-skeleton"
                  />
                </Col>

                <Col md={6} lg={6} xs={12}>
                  <Skeleton
                    count={4}
                    height={12}
                    className="plan-details-skeleton"
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </>
  );
};

export default PlanDetailsSkeleton;
